import { useMemo } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/api';

const useAxiosWithAuth = () => {
  const axiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // إضافة interceptors للتعامل مع التوثيق والأخطاء
    instance.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        // التعامل مع أخطاء انتهاء صلاحية التوكن
        if (error.response && error.response.status === 401) {
          // تحقق من أن الخطأ ليس من endpoint تسجيل دخول Taager
          const url = error.config?.url || '';
          const isTaagerAuthError = url.includes('/taager/auth');

          // فقط قم بتسجيل الخروج إذا لم يكن الخطأ من تسجيل دخول Taager
          // (لأن 401 من /taager/auth يعني أن بيانات Taager خاطئة وليس جلسة المستخدم)
          if (!isTaagerAuthError) {
            localStorage.removeItem('token');
            window.location.href = '/login';
          }
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, []);

  return axiosInstance;
};

export default useAxiosWithAuth;